<template>
  <v-card-text>
    <!-- Page Header -->
    <v-card class="custom-card px-4 py-2 mb-2">
      <v-row density="compact">
        <v-col cols="12" sm="6" md="6">
          <v-chip-group
            v-model="filterStatus"
            selected-class="bg-primary text-white border-primary"
            mandatory
          >
            <v-chip
              v-for="status in statusFilters"
              :key="status.value"
              :value="status.value"
              variant="outlined"
              color="white"
              class="font-weight-bold px-4"
            >
              {{ status.title }}
            </v-chip>
          </v-chip-group>
        </v-col>
        <v-col cols="12" sm="6" md="6" class="d-flex justify-end">
          <!-- <v-select
            variant="outlined"
            density="compact"
            color="primary"
            max-width="280"
            :items="[
              {
                title: 'Pending',
                value: 'PENDING',
              },
              {
                title: 'Approved',
                value: 'APPROVED',
              },
              {
                title: 'Rejected',
                value: 'REJECTED',
              },
            ]"
            v-model="filterStatus"
            hide-details
            label="Filter By Status"
          ></v-select> -->
        </v-col>
      </v-row>
    </v-card>

    <div>
      <v-card class="custom-card">
        <v-data-table
          :headers="headers"
          :items="GetAllCuratorRequestsList"
          :itemsPerPage="itemsPerPage"
          :height="vuetifyObject?.height - 205"
          v-model:page="page"
          class="elevation-0"
          density="compact"
          hide-default-footer
          :loading="loading"
          :items-per-page="10"
          @click:row="viewCuratorRequest"
        >
          <template v-slot:[`item.title`]="{ item }">
            <div class="font-weight-600">{{ item.title }}</div>
          </template>

          <template v-slot:[`item.workflow_status`]="{ item }">
            <v-chip
              :color="
                item.workflow_status === 'PENDING'
                  ? 'warning'
                  : item.workflow_status === 'APPROVED'
                  ? 'success'
                  : 'error'
              "
              size="small"
              class="font-weight-bold"
            >
              {{ item.workflow_status }}
            </v-chip>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex gap-2">
              <v-menu v-if="item.workflow_status == 'PENDING'">
                <template v-slot:activator="{ props }">
                  <v-btn
                    size="small"
                    variant="text"
                    icon="mdi-dots-vertical"
                    v-bind="props"
                  ></v-btn>
                </template>
                <v-list density="compact" class="text-subtitle">
                  <v-list-item
                    title="Approve/Reject"
                    @click="approveReject(item)"
                  >
                    <template v-slot:prepend>
                      <v-icon
                        size="small"
                        color="green"
                        icon="mdi-security"
                      ></v-icon>
                    </template>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-icon v-else color="primary">mdi-eye</v-icon>
            </div>
          </template>
        </v-data-table>
        <v-pagination
          density="compact"
          :length="pageCount"
          v-model="page"
        ></v-pagination>
      </v-card>
      <ViewCuratorRequestsDialog
        v-model:dialog="showDialog"
        :request="selectedRequest"
        @clicked="ViewCuratorRequestsDialogEmit"
      />
    </div>
  </v-card-text>
</template>

<script>
import ViewCuratorRequestsDialog from "@/components/CuratorRequests/Dialogs/ViewCuratorRequestsDialog.vue";
import { ListAllWorkflows } from "@/mixins/Extras/ListAllWorkflows";

export default {
  name: "RequestToPollPage",
  components: {
    ViewCuratorRequestsDialog,
  },
  props: {
    vuetifyObject: {
      type: Object,
      required: false,
    },
  },
  mixins: [ListAllWorkflows],
  data() {
    return {
      itemsPerPage: 100,
      page: 1,
      searchQuery: "",
      selectedSort: "newest",
      filterStatus: "PENDING",
      statusFilters: [
        {
          title: "Pending",
          value: "PENDING",
        },
        {
          title: "Approved",
          value: "APPROVED",
        },
        {
          title: "Rejected",
          value: "REJECTED",
        },
      ],
      loading: false,
      showDialog: false,
      selectedRequest: {},
      selectedPoll: {},
      headers: [
        { title: "User Name", key: "user_name", width: "20%" },
        { title: "User Email", key: "user_email_id", width: "20%" },
        { title: "Status", key: "workflow_status", width: "15%" },
        { title: "Comments", key: "comments", width: "30%" },
        { title: "Actions", key: "actions", sortable: false, width: "15%" },
      ],
      GetAllCuratorRequestsList: [],
    };
  },
  async mounted() {
    this.GetAllCuratorRequestsList = await this.GetAllWorkflowsMethod(
      this.filterStatus,
      "CURATOR_REQUEST",
    );
  },
  computed: {
    pageCount() {
      return Math.ceil(
        this.GetAllCuratorRequestsList?.length / this.itemsPerPage,
      );
    },
  },
  watch: {
    async filterStatus(newStatus) {
      this.GetAllCuratorRequestsList = await this.GetAllWorkflowsMethod(
        newStatus,
        "CURATOR_REQUEST",
      );
    },
  },
  methods: {
    viewCuratorRequest(row, request) {
      this.selectedRequest = request.item;
      this.showDialog = true;
    },
    approveReject(request) {
      this.selectedRequest = request;
      this.showDialog = true;
    },
    async ViewCuratorRequestsDialogEmit(Toggle) {
      if (Toggle == 2) {
        this.GetAllCuratorRequestsList = await this.GetAllWorkflowsMethod(
          this.filterStatus,
          "CURATOR_REQUEST",
        );
      }
    },
  },
};
</script>
<style></style>
